import { useEffect } from 'react';

// Injects one or more JSON-LD schema objects into <head>, cleaned up on unmount.
const StructuredData = ({ id, schema }) => {
  useEffect(() => {
    if (!schema) return undefined;
    const scriptId = `ld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(Array.isArray(schema) ? schema : [schema]);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [id, schema]);

  return null;
};

export default StructuredData;
